import { Avatar, Button, Dialog, DialogActions, DialogContent, DialogTitle, GridLegacy as Grid, IconButton, LinearProgress, List, ListItem, ListItemAvatar, ListItemText, Stack, Typography } from '@mui/material';
import React, { useRef, useState } from "react";
import { 
    Delete as DeleteIcon,
    UploadFile as FileIcon 
} from "@mui/icons-material";
import { ActionTypes } from "../../store/AppStore";
import { DialogType } from "../../utils/constants";


export const UploadFileMultiple = ({
    onAddFiles,
    actual_files = []
})=>{

    const uploadRef = useRef(null);
    const btnResetRef = useRef(null);
   
    const onChangeFileList = (evt)=>{
       try{

        let files = [...evt.target.files];
       
        let newFile = [];
        files?.forEach(file_item => {
            if ( ! actual_files.find( (file)=>file.file.name === file_item.name ) ){
                newFile.push(file_item); 
            }
        });
        
        onAddFiles( newFile );
        btnResetRef.current.click();

       }catch(e){
        console.log(e.message);
       }

    }
    const onClickAddDocument = ()=>{
       
        uploadRef.current.click();
    }

    return <>
      <Button onClick={onClickAddDocument} variant="contained" size="small" color="primary" >Añadir documento</Button>
        <form>
        <input   hidden ref={uploadRef}  onChange={onChangeFileList} type="file" multiple="true" accept=".txt" />
        <button hidden ref={btnResetRef} type="reset"  />
        </form>
    </>
}





export const UploadFileModal = ({
    is_opened,
    dispatch,
    onCloseAction,
    loadData
})=>{

    const [fileList,setFileList] = useState([]);
    const [isSending,setIsSending] = useState(false);

    const addFilesToList = (newFileList = [])=>{
        setFileList( fileList.concat(newFileList.map((file=>({file,progress:0,with_error:false})  ))));
    }
    const DropItemFormList = (index)=>{

        setFileList(  fileList.filter( (val,index_in)=>index_in !== index  ) );
    }
    
    const onSendFiles = async () => {
        dispatch({
            type: ActionTypes.setModalInfo,
            data: {
                title: "Funcionalidad descontinuada",
                message:
                    "El módulo de planos (impodatos) fue descontinuado. El envío de documentos al ERP se realiza por el servicio central.",
                type: DialogType.peligro,
                isVisible: true,
            },
        });
    }
     
    return (
       <>
    
        <Dialog
        open={is_opened}
        >
            <DialogTitle> Subida de planos </DialogTitle>
            <DialogContent>
                <Grid container >
                    <Grid item sm={12} xs={12} md={12} >
                        <UploadFileMultiple actual_files={fileList} onAddFiles={addFilesToList} />
                    </Grid>
                    <Grid item sm={12} xs={12} md={12} >
                    <Typography sx={{ mt: 4, mb: 2 }} fontSize={15} variant="h6" component="div">
                        Listado de archivos
                    </Typography>
                    <List >
                        {
                            fileList.map( (fileItem,indexFile)=>
                            <ListItem
                                key={fileItem.file.name}
                                secondaryAction={
                                    <IconButton onClick={e=>DropItemFormList(indexFile)} edge="end" aria-label="delete">
                                        <DeleteIcon sx={{color:"red"}} />
                                    </IconButton>
                                }
                                >
                                <ListItemAvatar>
                                    <Avatar>
                                    <FileIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    primary={fileItem.file.name}
                                    secondary={ <Stack direction={"column"} >
                                        <LinearProgress color="success" variant="determinate" value={fileItem.progress} />
                                         {fileItem.with_error  && <Typography>Error al tratar de subir el doc</Typography>}   
                                    </Stack>}
                                />
                                </ListItem> )
                        }

                    </List>
                    </Grid>
                </Grid>

            </DialogContent>
            <DialogActions>
                <Button onClick={onCloseAction}  variant="contained" color="secondary" >Cerrar</Button>
                <Button onClick={onSendFiles} variant="contained" color="primary" >Enviar planos</Button>
            </DialogActions>

        </Dialog>
       </>
    )
}